export const SET_POPUP = 'SET_POPUP';
export const SET_PERMISSION = 'SET_PERMISSION';
export const SET_ALL_PERMISSION = 'SET_ALL_PERMISSION';
export const PURGE_PERMISSION = 'PURGER_PERMISSION';
export const SET_USER_AFFIXE1 = 'SET_USER_AFFIXE1';
